export class CompanyMailConfig {

    private accountPassword: string;
    private accountUser: string;
    private auth: boolean;
    private code: string;
    private companyInternalId: string;
    private hostname: string;
    private internalId: string;
    private mailFrom: string;
    private mailName: string;
    private port: number;
    private ssl: boolean;
    private sslPort: number;

    constructor(accountPassword?: string, accountUser?: string, auth?: boolean, code?: string, companyInternalId?: string, hostname?: string, internalId?: string, mailFrom?: string, mailName?: string, port?: number, ssl?: boolean, sslPort?: number) {
        this.accountPassword = accountPassword;
        this.accountUser = accountUser;
        this.auth = auth;
        this.code = code;
        this.companyInternalId = companyInternalId;
        this.hostname = hostname;
        this.internalId = internalId;
        this.mailFrom = mailFrom;
        this.mailName = mailName;
        this.port = port;
        this.ssl = ssl;
        this.sslPort = sslPort;
    }

    public get AccountPassword() {
        return this.accountPassword;
    }
    public get AccountUser() {
        return this.accountUser;
    }
    public get Auth() {
        return this.auth;
    }
    public get Code() {
        return this.code;
    }
    public get CompanyInternalId() {
        return this.companyInternalId;
    }
    public get Hostname() {
        return this.hostname;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get MailFrom() {
        return this.mailFrom;
    }
    public get MailName() {
        return this.mailName;
    }
    public get Port() {
        return this.port;
    }
    public get Ssl() {
        return this.ssl;
    }
    public get SslPort() {
        return this.sslPort;
    }

    public set AccountPassword(accountPassword) {
        this.accountPassword = accountPassword;
    }
    public set AccountUser(accountUser) {
        this.accountUser = accountUser;
    }
    public set Auth(auth) {
        this.auth = auth;
    }
    public set Code(code) {
        this.code = code;
    }
    public set CompanyInternalId(companyInternalId) {
        this.companyInternalId = companyInternalId;
    }
    public set Hostname(hostname) {
        this.hostname = hostname;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set MailFrom(mailFrom) {
        this.mailFrom = mailFrom;
    }
    public set MailName(mailName) {
        this.mailName = mailName;
    }
    public set Port(port) {
        this.port = port;
    }
    public set Ssl(ssl) {
        this.ssl = ssl;
    }
    public set SslPort(sslPort) {
        this.sslPort = sslPort;
    }
}
